import { createStore } from 'vuex'

// 引入插件
import createPersistedState from "vuex-persistedstate"

export default createStore({
  state: {
    userInfo: {
      access_token: "", // 个人账户信息
    },
    store_currency: "USD", // 当前货币
  },
  getters: {
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    set_store_currency(state, params) {
      state.store_currency = params;
    },
  },
  actions: {
    setUserInfo(context, data) {
      context.commit("setUserInfo", data)
    },
    set_store_currency(context, params) {
      context.commit("set_store_currency", params);
    },
  },
  // vuex数据持久化配置 
  plugins: [
    createPersistedState({
      // 存储方式：localStorage sessionStorage cookies
      storage: window.sessionStorage,
      // 存储的 key 的key值
      key: "store",
    })
  ],
  modules: {
  }
})
